<template>
  <v-dialog
    v-model="show"
    max-width="1200"
    :fullscreen="this.$vuetify.breakpoint.xs"
  >
    <v-card>
      <v-row align="center" class="pa-5 ma-0">
        <v-col>
          <div class="text-left display-1">
            Account instellingen
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <v-btn icon @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <div class="pa-5">
              <div class="text-left display-1">
                Persoonlijke informatie
              </div>
              <v-row>
                <v-col md="8" cols="12">
                  <v-form spellcheck="false">
                    <v-text-field
                      label="Voornaam"
                      v-model="user.fname"
                    ></v-text-field>
                    <v-text-field
                      label="Achternaam"
                      v-model="user.lname"
                    ></v-text-field>
                    <v-text-field
                      label="Adres"
                      v-model="user.address"
                    ></v-text-field>
                    <v-text-field
                      label="Postcode"
                      v-model="user.zipcode"
                    ></v-text-field>
                    <v-text-field
                      label="Woonplaats"
                      v-model="user.city"
                    ></v-text-field>
                    <v-text-field
                      label="Kenteken"
                      v-model="user.license_plate"
                    ></v-text-field>
                    <v-text-field
                      label="Telefoonnummer"
                      v-model="user.phone_number"
                    ></v-text-field>
                  </v-form>
                </v-col>
                <v-col
                  class="text-center hidden-sm-and-down"
                  align-self="center"
                >
                  <v-icon size="150">mdi-account</v-icon>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <div class="pa-5">
              <v-btn
                @click="updateUser"
                class="no-text-transform display-1"
                color="primary"
                :loading="busyUpdating"
                >Wijzigingen opslaan
              </v-btn>
            </div>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SettingsDialog",
  props: ["init_tab", "value"],
  mounted() {
    if (this.init_tab) {
      this.tab = this.init_tab;
    }
  },
  data() {
    return {
      user: {},
      tab: 0,
      items: ["Profiel"],
      busyUpdating: false
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    show: function(val) {
      if (val) {
        let su = this.$store.getters["user/user"];
        Object.keys(su).forEach(key => {
          this.user[key] = su[key];
        });
        //TODO make a better implementation of code below
        this.user.fname = this.user.name.split(" ")[0];
        this.user.lname = this.user.name.substring(
          this.user.fname.length + 1,
          this.user.name.length
        );
        delete this.user.name;

        //setting tab
        if (this.init_tab) {
          this.tab = this.init_tab;
        }
      }
    }
  },
  methods: {
    updateUser() {
      let requestUser = {
        address: this.user.address,
        zipcode: this.user.zipcode,
        city: this.user.city,
        license_plate: this.user.license_plate,
        phone_number: this.user.phone_number
      };
      requestUser.name = this.user.fname + " " + this.user.lname;
      this.busyUpdating = true;
      this.$store
        .dispatch("user/update", requestUser)
        .then(response => {
          this.$store.commit("viewstate/globalSnackbar", {
            text: "Information updated",
            color: "success"
          });
          this.$store.commit("user/user", response.data);
        })
        .finally(() => {
          this.show = false;
          this.busyUpdating = false;
        });
    }
  }
};
</script>

<style scoped></style>
